(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atlas-slideshow')) {
    customElements.define('atlas-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.atlas-slide')];
        if (this.slides.length < 2 || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.atlas-slideshow-track');
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.delay = Math.max(4000, Number(this.dataset.delay) || 6000);
        this.querySelector('.atlas-slideshow-controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.goTo(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.index + 1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true), options));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          if (!this.paused) this.focused = false;
          this.updateToggle();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateToggle();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.goTo(selected, true);
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.updateToggle();
        this.goTo(0);
      }
      goTo(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) { this.paused = true; this.updateToggle(); }
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((slide, number) => {
          slide.inert = number !== this.index;
          slide.setAttribute('aria-hidden', String(number !== this.index));
        });
        this.dots.forEach((dot, number) => {
          if (number === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.querySelector('[data-slide-counter]').textContent = String(this.index + 1).padStart(2, '0');
        if (manual) this.querySelector('[data-slide-status]').textContent = this.slides[this.index].getAttribute('aria-label');
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-van-mats"]) return;
  try {
    
document.querySelectorAll('[data-atlas-mats]').forEach(root=>{
  const form=root.querySelector('[data-mat-filters]'),make=root.querySelector('[data-mat-make]'),model=root.querySelector('[data-mat-model]');
  const limitModels=()=>Array.from(model.options).forEach(option=>{option.hidden=Boolean(option.value&&make.value&&option.dataset.make!==make.value);option.disabled=option.hidden;});
  limitModels();
  make.addEventListener('change',()=>{model.value='';limitModels();});
  model.addEventListener('change',()=>{const option=model.selectedOptions[0];if(option.dataset.make){make.value=option.dataset.make;limitModels();}});
  form.addEventListener('submit',event=>{event.preventDefault();const tags=[make.value,model.value].filter(Boolean);const url=new URL(root.dataset.baseUrl,location.origin);if(tags.length)url.pathname+='/'+tags.map(encodeURIComponent).join('+');for(const [key,value] of new FormData(form)){if(String(value).trim())url.searchParams.set(key,value);}location.assign(url.href);});
  root.querySelector('[data-mat-sort]').addEventListener('change',()=>form.requestSubmit());
  root.querySelectorAll('[data-mat-view]').forEach(button=>button.addEventListener('click',()=>{root.classList.toggle('atlas-mats--list',button.dataset.matView==='list');root.querySelectorAll('[data-mat-view]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));}));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
